import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import {
    articleDetailResponse,
    articleResponse,
    keywordResponse,
    searchResponse,
    articleViewCountParams,
    journalMessage,
    responseMessage
} from 'src/interface/article';
import { EnvService } from './env.service';
import { faqResponse } from 'src/interface/faq';

@Injectable({
    providedIn: 'root',
})
export class GetArticlesService {
    clearSearch = false;
    urlChange = false;
    scite_badge_hover= new Subject<boolean>();
    constructor(private http: HttpClient, private env: EnvService) {}

    // getArticles(queryParams, journal_id: string): Observable<articleResponse> {
    //     return this.http.post<articleResponse>(
    //         this.env.siteApiUrl + 'web/articles',queryParams
    //     );
    // }

    getArticles(queryParams, journal_id: string): Observable<articleResponse> {     
           
        return this.http.get<articleResponse>(
            this.env.siteApiUrl + 'web/' + journal_id + '/articles',
            {
                params:  queryParams
            }
        );
    }

    getArticleView(queryParams): Observable<articleDetailResponse> {
        return this.http.get<articleDetailResponse>(
            this.env.siteApiUrl + 'web/article/data',
            {
                params: queryParams,
            }
        );
    }

    searchArticle(
        queryParams,
        journal_id: string
    ): Observable<articleResponse> {
        return this.http.get<articleResponse>(
            this.env.siteApiUrl + 'web/'+journal_id+'/article/search',
            {
                params: queryParams,
            }
        );
    }

    getKeywords(queryParams, journal_id: string): Observable<keywordResponse> {
        return this.http.get<keywordResponse>(
            this.env.siteApiUrl + 'web/' + journal_id + '/keywords',
            {
                params: queryParams,
            }
        );
    }

    commonSearch(queryParams) {
        return this.http.get<searchResponse>(
            this.env.siteApiUrl + 'web/commonSearch',
            {
                params: queryParams,
            }
        );
    }

    articleViewCount(
        queryParams: articleViewCountParams
    ): Observable<{ status: number; message: string }> {
        return this.http.post<{ status: number; message: string }>(
            this.env.siteApiUrl + 'web/article-view-count',
            queryParams
        );
    }
    articleDownloadCount(params): Observable<Blob> {
        return this.http.get(
            this.env.siteApiUrl + 'web/article-download-count',
            {
                responseType: 'blob',
                params: params,
            }
        );
    }

    checkFileExist(params):Observable<responseMessage>{
        return this.http.get<responseMessage>(
            this.env.siteApiUrl + 'web/file-exist',{
            params : params
            }
        );
    }

    checkJournal(queryParams): Observable<journalMessage> {
        return this.http.get<journalMessage>(
            this.env.siteApiUrl + 'web/check-journal',
            {
                params: queryParams,
            }
        );
    }

    downloadFile(params) {
        const headers = new HttpHeaders();
        headers.set('Accept', 'application/pdf/xml'); // Set the desired response type
        return this.http.get(
            this.env.siteApiUrl + 'web/article-download-supp-file',
            {
                responseType: 'blob',
                params: params,
                headers: headers,
            }
        );
    }
    getFaqData(queryParams): Observable<faqResponse> {
        return this.http.get<faqResponse>(this.env.siteApiUrl + 'web/faq-list', {
            params: queryParams,
        });
    }

    getVolumeIssue(queryParams): Observable<any> {
        return this.http.get<any>(this.env.siteApiUrl + 'web/volume-issue', {
            params: queryParams,
        });
    }

    fetchRelatedData(article_id): Observable<any> {
        return this.http.get<any>(
            this.env.siteApiUrl + 'web/article/related-article',
            {
                params: { article_id: article_id }, // Wrap the article_id in an object
            }
        );
    }

    sciteBadgeOver(scite_badge:boolean){
        this.scite_badge_hover.next(scite_badge);
    }

    // getThematic(query){
    //     return this.http.get<articleResponse>(
    //         this.env.siteApiUrl + 'web/thematic',
    //         {
    //             params:  query
    //         }
    //     );
    // }

    // getFavouriteArticles(favourites:favourites[]):Observable<articleResponse>{
    //     const favourites_data : any={
    //         favourite_array:favourites
    //     }
    //     return this.http.post<articleResponse>(
    //         this.env.siteApiUrl + 'web/favourites',favourites_data
    //     );
    // }
}
